export default __webpack_public_path__ + "static/media/white-avatar.50f5d4c6.png";